import React from 'react';
import { useQuery } from '@apollo/client';
import Activities from '../activities/Activities';
import { gql } from '../graphql/generated/gql';
import { isFeatureEnabled } from '../utils/features';
import ConnectionHelper from '../utils/graphql/ConnectionHelper';
import nonEmpty from '../utils/nonEmpty';
import HomeActivitiesV2 from './HomeActivitiesV2';

const ACTIVITIES_QUERY = gql(/** @complexity 164 */ `
  query activities($afterCursor: String) {
    activities(first: 10, after: $afterCursor) {
      edges {
        node {
          ...Activities_activities
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`);

const HomeActivitiesImpl = () => {
  const response = useQuery(ACTIVITIES_QUERY);

  const { data } = response;
  const fetchMore = ConnectionHelper.generateFetchMore(
    ACTIVITIES_QUERY,
    response,
    'activities',
  );

  return data?.activities?.edges ? (
    <Activities
      activities={data.activities.edges
        .map((edge) => edge?.node)
        .filter(nonEmpty)}
      fetchMore={fetchMore}
    />
  ) : null;
};

const HomeActivities = () => {
  return isFeatureEnabled('home_activity_v2') ? (
    <HomeActivitiesV2 />
  ) : (
    <HomeActivitiesImpl />
  );
};

export default HomeActivities;
